import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import 'boxicons';

import { useAuth } from 'hooks/useAuth';
import UserAvatar from 'components/UserAvatar';

const ProfileMenu = () => {
  const { t: translate } = useTranslation();
  const [menu, setMenu] = useState(false);
  const [userName, setUserName] = useState('');
  const { user } = useAuth();
  const { adminStatus } = user;

  useEffect(() => {
    if (!user) return;

    setUserName(`${user.name} ${user.lastName}`);
  }, [user]);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
        <DropdownToggle
          className="btn header-item d-flex align-items-center ps-0"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-xl-inline-block ms-2 me-1">{userName}</span>
          <UserAvatar.CurrentUser />
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {adminStatus === 'Super Admin' ? (
            <>
              <DropdownItem
                tag={Link}
                to="/create-account"
                className="d-flex justify-content-start align-items-center"
              >
                {' '}
                <box-icon
                  type="regular"
                  name="add-to-queue"
                  size="16px"
                  style={{ marginRight: '.3em' }}
                ></box-icon>
                {translate('Create Account')}{' '}
              </DropdownItem>
              <DropdownItem
                tag={Link}
                to="/list-accounts"
                className="d-flex justify-content-start align-items-center"
              >
                {' '}
                <box-icon
                  type="regular"
                  name="align-justify"
                  size="16px"
                  style={{ marginRight: '.3em' }}
                ></box-icon>
                {translate('List Accounts')}{' '}
              </DropdownItem>
              <div className="dropdown-divider" />
            </>
          ) : null}
          {adminStatus === 'Super Admin' || adminStatus === 'Admin' ? (
            <>
              <DropdownItem
                tag={Link}
                to="/create-user"
                className="d-flex justify-content-start align-items-center"
              >
                {' '}
                <box-icon
                  type="solid"
                  name="user-plus"
                  size="16px"
                  style={{ marginRight: '.3em' }}
                ></box-icon>
                {translate('Create User')}{' '}
              </DropdownItem>
              <DropdownItem
                tag={Link}
                to="/list-users"
                className="d-flex justify-content-start align-items-center"
              >
                {' '}
                <box-icon
                  type="solid"
                  name="user-detail"
                  size="16px"
                  style={{ marginRight: '.3em' }}
                ></box-icon>
                {translate('List Users')}{' '}
              </DropdownItem>
              <div className="dropdown-divider" />
            </>
          ) : null}
          <Link
            to="/edit-profile"
            className="dropdown-item d-flex justify-content-start align-items-center"
          >
            <box-icon
              type="regular"
              name="user"
              size="16px"
              style={{ marginRight: '.3em' }}
            ></box-icon>
            <span>{translate('Edit Profile')}</span>
          </Link>
          <Link
            to="/logout"
            className="dropdown-item d-flex justify-content-start align-items-center"
          >
            <box-icon
              type="regular"
              name="power-off"
              color="red"
              size="16px"
              style={{ marginRight: '.3em' }}
            ></box-icon>
            <span>{translate('Logout')}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
};

export default ProfileMenu;
